import { render, staticRenderFns } from "./AddStaff.vue?vue&type=template&id=d65a8606&"
import script from "./AddStaff.vue?vue&type=script&lang=js&"
export * from "./AddStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/AddStaff.vue
// module id = null
// module chunks = 